import { useLocation } from "react-router-dom";
import { useConfig } from "@/components/Layout";
import { trackEvent } from "@/lib/tracking";

function Star({ fill = 1 }) {
  // fill: 1 = voll, 0.8 = teilweise (z. B. 4,8/5), 0 = leer
  const id = `star-grad-${Math.round(fill * 100)}`;
  return (
    <svg className="w-4 h-4" viewBox="0 0 24 24" aria-hidden="true">
      <defs>
        <linearGradient id={id}>
          <stop offset={`${fill * 100}%`} stopColor="#e6a23c" />
          <stop offset={`${fill * 100}%`} stopColor="#32303c" />
        </linearGradient>
      </defs>
      <path
        d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
        fill={fill >= 1 ? "#e6a23c" : `url(#${id})`}
      />
    </svg>
  );
}

export default function GoogleReviewBadge({ position = "hero", variant = "compact" }) {
  const config = useConfig();
  const location = useLocation();
  const url = config?.google_profile_url;
  if (!url) return null;

  const rating = Number(config?.review_rating || 0);
  const count = config?.review_count || 0;
  const verified = !!(config?.google_reviews_verified && rating > 0 && count > 0);
  const ratingLabel = rating.toLocaleString("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 });

  const onClick = () => trackEvent("google_reviews_click", { page: location.pathname, position });

  if (!verified) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" onClick={onClick}
        data-testid={`google-reviews-link-${position}`}
        aria-label="Google-Bewertungen von Mabuhay ansehen – öffnet in einem neuen Tab"
        className="inline-flex items-center gap-2 text-xs text-[#a6a29d] hover:text-[#f4efe8] transition-colors underline underline-offset-4 decoration-[#32303c]">
        Unsere Google-Bewertungen ansehen
      </a>
    );
  }

  return (
    <a href={url} target="_blank" rel="noopener noreferrer" onClick={onClick}
      data-testid={`google-reviews-link-${position}`}
      aria-label="Google-Bewertungen von Mabuhay ansehen – öffnet in einem neuen Tab"
      className={`group inline-flex items-center gap-2.5 ${variant === "card" ? "bg-[#0e0e11] border border-[#32303c] rounded-lg px-5 py-4 hover:border-[#e6a23c]/60" : ""} transition-colors`}>
      <span className="inline-flex items-center gap-0.5" aria-hidden="true">
        {[1, 2, 3, 4, 5].map((i) => {
          const diff = rating - (i - 1);
          const fill = diff >= 1 ? 1 : diff > 0 ? Math.round(diff * 10) / 10 : 0;
          return <Star key={i} fill={fill} />;
        })}
      </span>
      <span className="text-sm text-[#f4efe8]">
        <strong className="font-bold">{ratingLabel}</strong>
        <span className="text-[#a6a29d]">/5 · {count} Rezensionen</span>
      </span>
      <span className="text-[10px] uppercase font-mono-brand tracking-wider text-[#8f8a85] group-hover:text-[#a6a29d] transition-colors">
        Quelle: Google
      </span>
    </a>
  );
}
